/**
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 在线模块路由
 */

import { RouteConfig } from 'vue-router'
/* Layout */
import Layout from '@/layout/index.vue'
 
const MediaWrite = () => import('@/views/online/media/index.vue')
const NormalWrite = () => import('@/views/online/normal/index.vue')
const OnlineWriteDetail = () => import('@/views/online/detail/index.vue')
// const MediaWriteDetail = () => import('@/views/online/media/_id.vue')
// const NormalWriteDetail = () => import('@/views/online/normal/_id.vue')
 
const utilsRoute: RouteConfig = {
    path: '/online',
    component: Layout,
    meta: {
        icon: 'icon-zaixianxz',
        title: '在线协助',
        alwaysShow: true                // will always show the root menu
    },
    children: [
        {
            path: 'media',
            component: MediaWrite,
            name: 'MediaWrite',
            meta: {
                title: '媒体人协助'
            }
        },
        {
            path: 'normal',
            component: NormalWrite,
            name: 'NormalWrite',
            meta: {
                title: '非媒体人协助'
            }
        },
        {
            path: 'detail/:id',
            component: OnlineWriteDetail,
            name: 'OnlineWriteDetail',
            meta: {
                hidden: true,
                title: '协助详情'
            }
        }
    ]
}
 
export default utilsRoute
 